/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
export var PROMETHEAN_BREAKPOINT_SM = 415;
export var PROMETHEAN_BREAKPOINT_MD = 769;
export var PROMETHEAN_BREAKPOINT_LG = 1168;
export var PROMETHEAN_BREAKPOINT_XL = 1441;
export var PROMETHEAN_BREAKPOINT_XXL = 1921;
export var PROMETHEAN_BREAKPOINT_NAV_CHANGE = 819;
export var PROMETHEAN_BREAKPOINT_CONTENT_AREA_MAX_WIDTH = 1760;
export var PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT = 1216;
export var PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT_MD = 1078;